// Google Maps loader service - checks if API is loaded
let loadPromise: Promise<void> | null = null;

export function loadGoogleMaps(): Promise<void> {
  // Already loaded via script tag
  if (window.google?.maps) {
    return Promise.resolve();
  }

  // Loading in progress
  if (loadPromise) {
    return loadPromise;
  }

  // Wait for the script tag to load (it's async)
  loadPromise = new Promise((resolve, reject) => {
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max wait
    
    const checkLoaded = () => {
      if (window.google?.maps) {
        console.log('✅ Google Maps API loaded');
        resolve();
        return;
      }
      
      attempts++;
      if (attempts >= maxAttempts) {
        reject(new Error('Google Maps API failed to load'));
        return;
      }
      
      setTimeout(checkLoaded, 100);
    };
    
    checkLoaded();
  });

  return loadPromise;
}

export function isGoogleMapsLoaded(): boolean {
  return !!window.google?.maps;
}
